// Navigate with an explicit market so stale cookies/URL fragments cannot win.
(() => {
  document.addEventListener('click', event => {
    const button=event.target.closest('[data-seronine-country-update-20260906]');
    if(!button||button.disabled)return;
    const panel=button.closest('.seronine-season-menu-20260906__country-panel');
    const selected=panel.querySelector('[data-seronine-country-option-20260906][aria-current="true"]');
    const country=selected?.getAttribute('data-country-code');
    if(!country)return;
    event.preventDefault();event.stopImmediatePropagation();
    const destination=new URL(location.href);
    destination.searchParams.set('country',country);
    destination.searchParams.delete('currency');
    if(window.Shopify?.theme?.role==='unpublished')destination.searchParams.set('preview_theme_id',window.Shopify.theme.id);
    button.disabled=true;button.textContent='UPDATING…';
    if(destination.href===location.href)location.reload();
    else location.assign(destination.href);
  },true);
})();
